import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "38",
  height: "38",
  viewBox: "0 0 38 38"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<defs><linearGradient id=\"a\" x1=\"8.042%\" x2=\"65.682%\" y1=\"0%\" y2=\"23.865%\"><stop offset=\"0%\" stop-opacity=\"0\"></stop><stop offset=\"63.146%\" stop-opacity=\".631\"></stop><stop offset=\"100%\"></stop></linearGradient></defs><g fill=\"none\" fill-rule=\"evenodd\" transform=\"translate(1 1)\"><path stroke=\"url(#a)\" stroke-width=\"2\" d=\"M36 18c0-9.94-8.06-18-18-18\"><animateTransform attributeName=\"transform\" dur=\"0.9s\" from=\"0 18 18\" repeatCount=\"indefinite\" to=\"360 18 18\" type=\"rotate\"></animateTransform></path><circle cx=\"36\" cy=\"18\" r=\"1\" fill=\"#fff\"><animateTransform attributeName=\"transform\" dur=\"0.9s\" from=\"0 18 18\" repeatCount=\"indefinite\" to=\"360 18 18\" type=\"rotate\"></animateTransform></circle></g>", 2)
  ]))]))
}
export default { render: render }